import React from 'react'

import { SiteHeaderContainer } from '../../header'
import { MainMenu } from '../../mainMenu'
import { SearchBar } from '../../search'

const CmsSiteHeader = () => (
  <>
    <SiteHeaderContainer>
      <MainMenu />
    </SiteHeaderContainer>
    <SearchBar />
  </>
)

export default CmsSiteHeader
